export default "__VITE_ASSET__DN$nRgRQ__"